import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import stepSlice from "../context/StepsContext";
import { titleExtractor, titleNormalizer, uniqueIdBuilder } from "../util/Dynamics";
import PopupTextField from "./ui-el/PopupTextField";

import "../global.css"

function SelectionFormBox(props) {
    const dispatcher = useDispatch();
    const title = Array.isArray(props?.title) ? props.title[1] : props.title;
    const isSelectOnly = props.variant === "selectOnly";
    const placeholderValue = "";

    const classSet = (e) => {
        const id = titleNormalizer(e.target.parentNode.children[0].textContent);
        const titleTop = titleNormalizer(props?.title[0]);

        // dispatcher(stepSlice
        //     .actions
        //     .dynamicSave({id:props.oKey,topId: titleTop,internalId: id, data: e.target.value,remove: false,test: true}));

        props.update({
            id: "classe",
            data: e.target.value
        });
    }

    const defaultOptionId = useMemo(() => {
        if (!Array.isArray(props?.choices) || props.defaultValue === undefined || props.defaultValue === null) {
            return placeholderValue;
        }

        const match = props.choices.find(
            (option) =>
                option?.value === props.defaultValue ||
                String(option?.id) === String(props.defaultValue)
        );

        return match ? String(match.id) : placeholderValue;
    }, [props.defaultValue, props.choices]);

    const [selectedValue, setSelectedValue] = useState(defaultOptionId);

    useEffect(() => {
        setSelectedValue(defaultOptionId);
    }, [defaultOptionId]);

    const handleChange = (e) => {
        const value = e.target.value;
        setSelectedValue(value);

        const selectedOption = props.choices?.find((option) => String(option?.id) === value);
        const data = selectedOption?.value ?? e.target.options[e.target.selectedIndex]?.textContent;

        props.update({
            id: props?.id || titleNormalizer(title),
            selectionID: value,
            internalId: props?.internalId ?? null,
            data
        });
    };

    if (isSelectOnly) {
        const selectId = "select-school";

        return (
            <div className="form-group cmp-input top-move">
                <label
                    className={`cmp-input__label active ${props.disabled ? "disabled" : ""}`}
                    htmlFor={selectId}
                >
                    {titleExtractor(props.showTitle || title)}
                </label>

                <p style={{ display: "none" }}>{title}</p>

                <select
                    id={selectId}
                    style={{
                        fontWeight: "600",
                        border: "none",
                        borderBottom: "solid 1.5px grey",
                        boxShadow: "none",
                        padding: "5px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                    }}
                    required
                    onChange={handleChange}
                    value={selectedValue}
                    className={`${props.disabled ? "disabled" : ""} full-btn-file`}
                    disabled={props.disabled}
                >
                    <option value={placeholderValue} disabled>
                        {props?.firstSelection ? props.firstSelection : "Seleziona un opzione"}
                    </option>
                    {
                        Array.isArray(props?.choices) &&
                        props.choices?.map((option, idx) => {
                            return (
                                <option
                                    value={String(option.id)}
                                    key={uniqueIdBuilder()}
                                    style={{
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis"
                                    }}
                                >
                                    {option.value}
                                </option>
                            )
                        })
                    }
                </select>

                <div className="d-flex">
                    <span className="form-text cmp-input__text">
                        {props.description ? props.description : "Inserire l’informazione per proseguire con la richiesta"}
                    </span>
                </div>
            </div>
        )
    }

    return (
        <section className="it-page-section" id="school-choice">
            <div className="cmp-card mb-40">
                <div className={`card has-bkg-grey p-big p-4  ${props.disp === "disp" ? "box-remover" : ""}`}>
                    <div className={`card-header border-0 p-0 mb-lg-30`}>
                        <div className="d-flex">
                            <h1 className="title-xlarge mb-0">
                                {titleExtractor(props.showTitle)}
                            </h1>
                        </div>
                        <p className="subtitle-small mb-0">
                            {props.description}
                        </p>
                    </div>
                    <div className={`card-body p-0  ${props.disp === "disp" ? "box-enlighter" : ""}`}>
                        <div className="select-wrapper p-big p-4 select-partials">
                            <p style={{ display: "none" }}>{title}</p>
                            <label htmlFor="select-school" className="visually-hidden">
                                {props.selectTitle}
                            </label>

                            <select
                                id="select-school"
                                style={{
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis"
                                }}
                                required
                                onChange={handleChange}
                                value={selectedValue}
                                className={`${props.disabled ? "disabled" : ""}`}
                                disabled={props.disabled}
                            >
                                <option value={placeholderValue} disabled>
                                    {props?.firstSelection ? props.firstSelection : "Seleziona un opzione"}
                                </option>
                                {
                                    Array.isArray(props?.choices) &&
                                    props.choices?.map((option, idx) => {
                                        return (
                                            <option
                                                value={String(option.id)}
                                                key={uniqueIdBuilder()}
                                            >
                                                {option.value}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    <br />
                    {
                        title === "SCUOLA" &&
                        <PopupTextField
                            id="classe"
                            defaultValue={props.classDefaultValue}
                            onChange={classSet}
                            fieldType="text"
                            fieldTitle="Classe"
                            description="Inserisci la classe*" />
                    }
                    {props.children}
                </div>
            </div>
        </section>
    )
}

export default SelectionFormBox;
